import { useEffect, useState, useCallback } from "react";
import api from "../api";
import FiscalChecklist from "../components/FiscalChecklist";
import RedditiChecklist from "../components/RedditiChecklist";

const MESI = ["", "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const fmtIt = (d) => d.split("-").reverse().join("/");

export default function ScadenzarioFiscale() {
  const [data, setData] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());

  const load = useCallback(() => {
    api.get(`/scadenze/fiscali?year=${year}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [year]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (it) => {
    if (it.auto_handled) return;
    if (it.manual_done) await api.delete(`/scadenze/done?key=${encodeURIComponent(it.key)}`);
    else await api.post("/scadenze/done", { key: it.key, label: it.label, date: it.date });
    load();
  };

  const [addForm, setAddForm] = useState(null); // {label, recurring, date, day, month}
  const [checklist, setChecklist] = useState(null); // scadenza aperta nella checklist clienti
  const saveCustom = async () => {
    if (!addForm.label.trim()) { alert("Indica la descrizione della scadenza"); return; }
    try {
      await api.post("/scadenze/fiscali", {
        label: addForm.label.trim(), recurring: addForm.recurring,
        date: addForm.recurring ? null : addForm.date || null,
        day: addForm.recurring ? parseInt(addForm.day || 0, 10) : null,
        month: addForm.recurring ? parseInt(addForm.month || 0, 10) : null,
      });
      setAddForm(null); load();
    } catch (e) { alert(e.response?.data?.detail || e.message); }
  };
  const delCustom = async (it) => {
    if (!window.confirm(`Eliminare la scadenza "${it.label}"${it.recurring ? " da tutti gli anni" : ""}?`)) return;
    await api.delete(`/scadenze/fiscali/${it.custom_id}`);
    load();
  };

  if (!data) return <p className="muted">Caricamento…</p>;
  const next = data.items.find((it) => !it.auto_handled && !it.manual_done);
  const byMonth = {};
  data.items.forEach((it) => { const m = parseInt(it.date.slice(5, 7), 10); (byMonth[m] = byMonth[m] || []).push(it); });

  return (
    <div>
      <h1 className="page-title">Scadenzario fiscale</h1>
      <p className="page-sub">Adempimenti annuali dello Studio (LIPE, IVA, redditi, bilanci, CU…). Le scadenze passate risultano gestite automaticamente ed entrano nel report attività dei clienti.</p>

      <div className="toolbar" style={{ marginBottom: 12 }}>
        <div className="tabs" style={{ margin: 0 }}>
          {data.years.map((y) => (
            <button key={y} className={y === data.year ? "active" : ""} onClick={() => setYear(y)} data-testid={`fiscal-year-${y}`}>{y}</button>
          ))}
        </div>
        <div className="spacer" />
        <span className="pill gestita" data-testid="fiscal-progress">{data.handled} di {data.total} gestite</span>
        <button className="btn sm primary" onClick={() => setAddForm({ label: "", recurring: false, date: "", day: "", month: "" })} data-testid="fiscal-add-btn">+ Aggiungi scadenza</button>
      </div>

      {addForm && (
        <div className="panel" style={{ borderLeft: "4px solid #38bdf8" }} data-testid="fiscal-add-form">
          <h3 style={{ marginTop: 0 }}>Nuova scadenza fiscale</h3>
          <div className="field"><label>Descrizione *</label>
            <input value={addForm.label} onChange={(e) => setAddForm({ ...addForm, label: e.target.value })} placeholder="es. Rinnovo firma digitale, Diritto camerale…" data-testid="fiscal-add-label" />
          </div>
          <div className="field"><label>Tipo</label>
            <select value={addForm.recurring ? "tutti" : "unatantum"} onChange={(e) => setAddForm({ ...addForm, recurring: e.target.value === "tutti" })} data-testid="fiscal-add-type">
              <option value="unatantum">Una tantum (solo una data precisa)</option>
              <option value="tutti">Ogni anno (si ripete in tutti gli anni)</option>
            </select>
          </div>
          {addForm.recurring ? (
            <div className="grid-2">
              <div className="field"><label>Giorno *</label>
                <input type="number" min="1" max="31" value={addForm.day} onChange={(e) => setAddForm({ ...addForm, day: e.target.value })} data-testid="fiscal-add-day" />
              </div>
              <div className="field"><label>Mese *</label>
                <select value={addForm.month} onChange={(e) => setAddForm({ ...addForm, month: e.target.value })} data-testid="fiscal-add-month">
                  <option value="">—</option>
                  {MESI.slice(1).map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
                </select>
              </div>
            </div>
          ) : (
            <div className="field"><label>Data *</label>
              <input type="date" value={addForm.date} onChange={(e) => setAddForm({ ...addForm, date: e.target.value })} data-testid="fiscal-add-date" />
            </div>
          )}
          <div className="modal-actions">
            <button className="btn" onClick={() => setAddForm(null)}>Annulla</button>
            <button className="btn primary" onClick={saveCustom} data-testid="fiscal-add-save">Salva scadenza</button>
          </div>
        </div>
      )}

      {next && (
        <div className="panel" style={{ borderLeft: "4px solid #f59e0b" }} data-testid="fiscal-next">
          <strong>Prossima scadenza:</strong> {fmtIt(next.date)} — {next.label}
        </div>
      )}

      {Object.keys(byMonth).sort((a, b) => a - b).map((m) => (
        <div className="panel" key={m}>
          <h3 style={{ marginTop: 0 }}>{MESI[m]} {data.year}</h3>
          <table>
            <thead><tr><th style={{ width: 40 }}></th><th style={{ width: 110 }}>Scadenza</th><th>Adempimento</th><th style={{ width: 130 }}>Stato</th></tr></thead>
            <tbody>
              {byMonth[m].map((it) => {
                const done = it.auto_handled || it.manual_done;
                return (
                  <tr key={it.key} style={{ opacity: done ? 0.75 : 1 }} data-testid={`fiscal-row-${it.key}`}>
                    <td>
                      <input type="checkbox" checked={done} disabled={it.auto_handled}
                        onChange={() => toggle(it)} data-testid={`fiscal-check-${it.key}`}
                        title={it.auto_handled ? "Gestita automaticamente (data passata)" : "Segna come gestita in anticipo"} />
                    </td>
                    <td style={{ whiteSpace: "nowrap", fontWeight: 700, color: done ? "var(--green)" : "inherit" }}>{fmtIt(it.date)}</td>
                    <td>
                      <button className="fiscal-item-link" onClick={() => setChecklist(it)} title="Apri la checklist clienti (fatto / inviato)" data-testid={`fiscal-open-${it.key}`}>
                        {it.label}
                      </button>
                      {it.custom_id && <span className="pill" style={{ marginLeft: 6, fontSize: 10 }}>personalizzata</span>}
                    </td>
                    <td>{done
                      ? <span className="pill gestita">✓ Gestita</span>
                      : <span className="pill da_gestire">Da gestire</span>}
                      {it.custom_id && <button className="btn sm danger" style={{ marginLeft: 8 }} onClick={() => delCustom(it)} title="Elimina scadenza personalizzata" data-testid={`fiscal-del-${it.custom_id}`}>🗑</button>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
      {checklist && (/modello redditi/i.test(checklist.label)
        ? <RedditiChecklist year={parseInt(checklist.date.slice(0, 4), 10)} date={checklist.date} onClose={() => setChecklist(null)} />
        : <FiscalChecklist item={checklist} onClose={() => setChecklist(null)} />)}
    </div>
  );
}
